import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import queryString from 'query-string';
import {
  Container,
  Divider,
  Header,
  List,
  Loader,
  Segment
} from 'semantic-ui-react';
import ReactTable from 'react-table';
import feathersConnect from './../../../providers/feathersConnect';

const INITIAL_STATE = {
  loading: false,
  error: null,
  data: null
};

class ReportePersonaView extends Component {

  constructor (props) {
    super(props);

    this.state = INITIAL_STATE;

    this.PersonaService = this.props.feathers.service('/api/personas');
  }

  findPersona () {
    this.setState({
      loading: true,
      error: null,
      data: null
    });

    let query = queryString.parse(this.props.location.search);

    this.PersonaService.get(query.id, {
      query: {
        report: true
      }
    })
      .then(response => {
        this.setState({
          loading: false,
          data: response
        }, () => {
          // window.print();
        });
      })
      .catch(error => {
        this.setState({
          loading: false,
          error
        });
      });
  }

  componentDidMount () {
    this.findPersona();
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let {
      loading,
      data,
      error
    } = this.state;

    console.log(data);

    if (loading) {

      return (
        <Container fluid>
          <Loader active content="Cargando" inline="centered" />
        </Container>
      );

    } else if (data) {

      return (
        <Container>
          <Header as="h4" textAlign="center">Información no certificada por el Estado Provincial</Header>
          <Header as="h2">
            {data.apellido}, {data.nombre}
            <Header.Subheader>
              DNI {data.dni}
            </Header.Subheader>
          </Header>
          <Header attached="top" as="h4" content="Esta asociado a:" />
          <Segment attached="bottom">
            {
              data.cooperativas.length ?
                <List divided relaxed>
                  {
                    data.cooperativas.map((cooperativa, index) => (
                      <List.Item key={index}>
                        <List.Content>
                          <List.Header>{cooperativa.nombre}</List.Header>
                          <List.Description>
                            M.N. {cooperativa.matriculaNacional} M.P. {cooperativa.matriculaProvincial}
                          </List.Description>
                        </List.Content>
                      </List.Item>
                    ))
                  }
                </List> : <Header as="h4" content="Sin asociaciones" />
            }
          </Segment>
        </Container>
      );

    } else {

      return (
        <Container fluid>
          Error
        </Container>
      );

    }
  }
}

export default feathersConnect(
  connect(
    ReportePersonaView.mapStateToProps,
    ReportePersonaView.mapDispatchToProps
  )(ReportePersonaView)
);



// WEBPACK FOOTER //
// ./client/components/pages/informes/ReportePersonaView.js